import { env } from '@/env';
import type { PropsWithChildren } from 'react';

/**
 * Hides its children in dynamic environments (where a dynamic backend URL is
 * configured). Use to skip features that don't work in dynamic envs, e.g.
 * anything depending on the integration-manifest fetch.
 */
export function HiddenOnDynamicEnvs({ children }: PropsWithChildren) {
  const isDynamicEnv =
    typeof env.NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL === 'string' &&
    env.NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL.length > 1;

  if (isDynamicEnv) {
    return null;
  }

  return <>{children}</>;
}
